module.exports = __webpack_public_path__ + "img/AufDenPreisEinigen.dacb5541.svg";